import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import routes from './routes'
import VueRouteMiddleware from './../middleware/VueRouteMiddleware'
import authMiddleware from './../middleware/authMiddleware'
import guestMiddleware from './../middleware/guestMiddleware'
import isSacrificialMiddleware from '../middleware/isSacrificialMiddleware'

Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})

const router = new VueRouter({
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach(VueRouteMiddleware({
  guestMiddleware,
  authMiddleware,
  isSacrificialMiddleware,
}))

export default router
